// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"e870bddf","453":"23c2eabf","481":"d5bc41b5","811":"df1c384a","817":"19361d7d"}[chunkId] + ".chunk.js";
};